import { Box, makeStyles } from "@material-ui/core";
import { useSelector } from "react-redux";
import PadIndex from "../../components/SelfPickup/PadIndex";
import SearchIndex from "../../components/SelfPickup/SearchIndex";
import { getOpenSelfPickupSection } from "../../reducers/uiSlice";

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: '#3a3a3a',
        overflow: 'hidden',
        height: '100vh',
        margin: 0
    }
}))

function SelfPickup() {
    const classes = useStyles();

    // 0 -> search
    // 1 -> list
    // 2 -> scan
    // 3 -> confirm
    const openStage = useSelector(getOpenSelfPickupSection);

    return (
        <Box className={classes.root}>
            {
                openStage === 0 &&
                <SearchIndex />
            }
            {
                openStage !== 0 &&
                <PadIndex />
            }
        </Box>
    )
}

export default SelfPickup;